import React, { FC } from 'react';
import { WeldChipContainerStyled, WeldActionStyled, WeldTimePeriodStyled } from './styled';
import { useLingui } from '@lingui/react';
import { WeldStatusMessages } from '~/components/atoms/i18n-message-keys';
import { Box, Text, useSideSheetState } from '@bechtel/gds';
import { Block, BlockStatusCode, CommodityStatusCode, Weld } from '@bechtel/types';
import { useDate, useConfig, RestrictTo, useAppUser } from '@bechtel/client-common';
import { parseISO } from 'date-fns';
import { WeldDetailActions } from './detail';
import { NewRodRequest } from '../create-rod-request-sidesheet';
import { flatMap, some } from 'lodash';
export interface WeldActionsProps {
  weld: Weld;
}

export const WeldActions: FC<WeldActionsProps> = ({ weld }) => {
  const { i18n } = useLingui();
  const { formatRelativeInWords } = useDate();
  const { dateFormat } = useConfig();
  const { user } = useAppUser();
  const {
    visible: visibleNewRodRequest,
    open: openNewRodRequestSideSheet,
    close: closeNewRodRequestSideSheet,
  } = useSideSheetState(false);
  const personaType = user?.crewMember?.persona;
  const blocks = flatMap(weld.milestones,'blocks');
  const hasOpenBlocks = some(blocks, (item:Block) =>  item.currentStatusI18n == BlockStatusCode.BLOCK_OPENED)
  const weldStatus = (hasOpenBlocks) ? CommodityStatusCode.BLOCKED : weld.status?.status!
  return (
    <WeldActionStyled>
      <Box mr={{ sm: '300' }} flexShrink={{ sm: '0' }} justifyContent={{ sm: 'flex-start' }}>
        <WeldChipContainerStyled status={weldStatus}>
          <Box px={{ sm: '450' }} py={{ sm: '300' }} alignItems={{ sm: 'center' }} justifyContent={{ sm: 'center' }}>
            <Text family="graphik" color="white" size="400" weight="600">
              {i18n._(WeldStatusMessages[weldStatus])}
            </Text>
          </Box>
        </WeldChipContainerStyled>
        <WeldTimePeriodStyled>
          {weld.status?.statusAt &&
            formatRelativeInWords(parseISO(weld.status?.statusAt), new Date(), RestrictTo.Day, dateFormat, ``, true)}
        </WeldTimePeriodStyled>
      </Box>

      <WeldDetailActions
        weld={weld}
        createRodRequest={openNewRodRequestSideSheet}
        isVisibleOnWeldSubHeader={true}
        personaType={personaType}
      />
      {visibleNewRodRequest && <NewRodRequest onClose={closeNewRodRequestSideSheet} welds={[weld]} />}
    </WeldActionStyled>
  );
};
